import { Button, Card, enhancedFetch, Search, SearchBox, SearchResults, ssrBuilder } from 'journey-ui'
import { NextPageContext } from 'next'
import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import { AppPage } from '../components/AppPage'
import { BrandHeader } from '../components/BrandHeader'
import { AppContext } from '../contexts/AppContext'
import { redirectIfNoBrand } from '../helpers'
import { gtag } from '../lib/gtag'

type Props = {
  brand: Brand
}

const AdminPage: React.FC<Props> = ({ brand }) => {
  const { user, setUser } = useContext(AppContext)
  const router = useRouter()

  if (!user || !user.is_pizzamico_team) {
    return null
  }

  const onHitClick = async (hit) => {
    const newUser = await enhancedFetch<User>('/api/admin/impersonate', {
      method: 'POST',
      body: {
        user_hash_id: hit.hash_id,
      },
    })

    setUser(newUser)

    await router.push('/')
  }

  const sendConversionEvent = () => {
    if (!brand.google_tag_conversion_id) {
      alert('No google tag converison id set on brand.')
      return
    }

    gtag.conversion(brand.google_tag_conversion_id, 'r4mkr8lroxx2hmpdq7wq2ly7sk5', 999)

    alert('Sent conversion!')
  }
  return (
    <AppPage brand={brand} title="Admin" description="Admin panel." className="full-screen">
      <BrandHeader className="h-40">
        <h2 className="text-3xl z-20 font-bold">
          Admin
        </h2>
      </BrandHeader>
      <div className="p-2 flex justify-center">
        <Card className="max-w-[1080px] space-y-4">
          <div>
            <div className="font-bold">Impersonate User</div>
            <Search paginateProps={(txt, isInputFocused) => ({
              url: `/api/admin/search-users?name_search=${txt}&brand_hash_id=${brand.hash_id}`,
              isAllowed: txt.length > 0 && isInputFocused,
              key: 'name',
            })}
            >
              <SearchBox
                placeholder="Search user...."
                className="min-h-0 h-10 text-black"
              />
              {/* <SearchResultsPopover> */}
              <SearchResults>
                {(hits) => hits.map((hit) => (
                  <Button key={hit.name} className="flush" onClick={() => onHitClick(hit)}>
                    {hit.name}
                  </Button>
                ))}
              </SearchResults>
              {/* </SearchResultsPopover> */}
            </Search>
          </div>
          <div>
            <div className="font-bold">Simulate Google Ad Conversion</div>
            <Button onClick={sendConversionEvent}>
              Send Conversion Event
            </Button>
          </div>
        </Card>
      </div>
    </AppPage>
  )
}

// noinspection JSUnusedGlobalSymbols (PHPStorm doesn't detect NextJS's pages)
export default AdminPage

export async function getServerSideProps(ctx) {
  return ssrBuilder(ctx)
    .setProp('brand', (fetcher) => fetcher(`/api/brand/${ctx.req.headers.host}`))
    .onError(redirectIfNoBrand)
    .get()
}
